import { usePostProtocolVersionApi, usePutProtocolVersionApi } from 'api/protocol_version'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useEffect, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { ProtocolVersion, ProtocolVersionForm, ProtocolVersionProbes, ProtocolVersionSearchForm, QC_TYPE_SELECT_ITEMS } from 'entities/protocol_version'
import { CheckboxField, InputField, SelectField } from 'components/shared/input'
import { useFetchProtocolVersionsApi } from 'api/protocol_version'
import SelectProbeModal from 'components/probe/select_probe_modal'
import { Probe } from 'entities/probe'

type UserFormViewProps = {
    form: Form<ProtocolVersionForm>
    apiError: ApiError
    isStandardQc?: boolean
}

export const UserFormView = ({ form, apiError, isStandardQc }: UserFormViewProps) => {
    const qcVersionsForm = useForm<ProtocolVersionSearchForm>({})
    const qcVersionsApi = useFetchProtocolVersionsApi(qcVersionsForm)

    useEffect(() => {
        qcVersionsApi.execute()
    }, [])

    return (
        <>
            <div style={{ marginTop: 20 }}>
                {form.object.protocolVersionProbes && form.object.protocolVersionProbes?.length > 0 ? (
                    <div style={{ marginTop: 20 }}>
                        <div style={{ padding: 10 }}>
                            <Table style={{ verticalAlign: 'middle' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 200 }}>Probe</th>
                                        {(!form.object.productItemId || isStandardQc) && <th style={{ minWidth: 200 }}>QC type</th>}
                                        <th>Min range</th>
                                        <th>Max range</th>
                                        {isStandardQc && <>
                                            <th>LCL</th>
                                            <th>UCL</th>
                                            <th>R-UCL</th>
                                        </>}
                                        {!isStandardQc && <>
                                            <th>Ct Min Range</th>
                                            <th>Ct Max Range</th>
                                            <th>Is Negative Marker</th>
                                        </>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {form.object.protocolVersionProbes?.map((item, index) => {
                                        return (
                                            <tr key={'probes-' + index}>
                                                <td>
                                                    <div>{item.probe?.name}</div>
                                                </td>

                                                {(!form.object.productItemId || isStandardQc) && (
                                                    <th>
                                                        <SelectField
                                                            style={{ marginBottom: 0 }}
                                                            form={form}
                                                            attr={['protocolVersionProbes', index, 'qcType']}
                                                            selectItems={QC_TYPE_SELECT_ITEMS}
                                                            required
                                                            includeBlank
                                                        />
                                                    </th>
                                                )}
                                                <td>
                                                    <InputField
                                                        style={{ marginBottom: 0 }}
                                                        form={form}
                                                        attr={['protocolVersionProbes', index, 'minRange']}
                                                        type="number"
                                                        required
                                                    />
                                                </td>
                                                <td>
                                                    <InputField
                                                        style={{ marginBottom: 0 }}
                                                        form={form}
                                                        attr={['protocolVersionProbes', index, 'maxRange']}
                                                        type="number"
                                                        required
                                                    />
                                                </td>
                                                {isStandardQc && <>
                                                    <td>
                                                        <InputField
                                                            style={{ marginBottom: 0 }}
                                                            form={form}
                                                            attr={['protocolVersionProbes', index, 'xlcl']}
                                                            type="number"
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <InputField
                                                            style={{ marginBottom: 0 }}
                                                            form={form}
                                                            attr={['protocolVersionProbes', index, 'xucl']}
                                                            type="number"
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <InputField
                                                            style={{ marginBottom: 0 }}
                                                            form={form}
                                                            attr={['protocolVersionProbes', index, 'rucl']}
                                                            type="number"
                                                            required
                                                        />
                                                    </td></>}
                                                {
                                                    !isStandardQc && <>
                                                        <td>
                                                            <InputField
                                                                style={{ marginBottom: 0 }}
                                                                form={form}
                                                                attr={['protocolVersionProbes', index, 'ctMinRange']}
                                                                type="number"
                                                                required
                                                            />
                                                        </td>
                                                        <td>
                                                            <InputField
                                                                style={{ marginBottom: 0 }}
                                                                form={form}
                                                                attr={['protocolVersionProbes', index, 'ctMaxRange']}
                                                                type="number"
                                                                required
                                                            />
                                                        </td>
                                                        <td>
                                                            <CheckboxField form={form} attr={['protocolVersionProbes', index, 'isNegativeMarker']} label='' checkboxLabel=' ' />
                                                        </td>
                                                    </>
                                                }
                                                {/* <td>
                                                        <SelectField
                                                            style={{ marginBottom: 0 }}
                                                            form={form}
                                                            attr={['probeForms', index, 'sortNumber']}
                                                            selectItems={QC_TYPE_SELECT_ITEMS}
                                                            includeBlank
                                                        />
                                                    </td> */}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                ) : (
                    <div style={{ padding: '50px 20px', textAlign: 'center', backgroundColor: '#fafafa', borderRadius: 5 }}>プローブを選択してください</div>
                )}
            </div>

            <SelectProbeModal
                openButtonStyle={{ width: '100%', marginTop: 10 }}
                openButtonText="Probe選択"
                executeButtonText="追加"
                onClick={(probes: Probe[]) => {
                    form.update((f) => {
                        f.protocolVersionProbes = probes.map((p) => {
                            return { probe: p }
                        }) as ProtocolVersionProbes[]
                    })
                }}
                initialItems={form.object.probes}
            />
        </>
    )
}

type NewProtocolVersionFormProps = {
    onComplete?: () => void
    productItemId?: number
    isStandardQc?: boolean
}

export const NewProtocolVersionForm = (props: NewProtocolVersionFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostProtocolVersionApi()
    const form = useForm<ProtocolVersionForm>({ productItemId: props.productItemId })
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{props.productItemId && !props.isStandardQc ? 'がん検査の登録' : 'QC設定の登録'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserFormView form={form} apiError={api.apiError} isStandardQc={props.isStandardQc} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditProtocolVersionFormProps = {
    protocolVersion: ProtocolVersion
    show: boolean
    onClose: () => void
    onComplete?: () => void
    isStandardQc?: boolean
}

export const EditProtocolVersionForm = (props: EditProtocolVersionFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutProtocolVersionApi()
    const form = useForm<ProtocolVersionForm>(props.protocolVersion)

    useEffectSkipFirst(() => {
        form.set(props.protocolVersion)
    }, [props.protocolVersion])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal size='xl' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{props.protocolVersion.productItem?.id ? 'がん検査の編集' : 'QC設定の編集'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <UserFormView form={form} apiError={api.apiError} isStandardQc={props.isStandardQc} />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
